export default __webpack_public_path__ + "static/media/1526.ce4b908d.png";